import { getPriorityLabel } from 'app/config/aboxConfig';
import { TRANSLATION_KEYS } from 'app/config/changelogConfig';
import { DATE_FORMAT, formatDate, isIsoDate } from '../date/date';
import { get, set } from '../lo/lo';
import { isBoolean, isObject } from '../utils';

const singleActions = ['add', 'remove'];

const checkIfMultipleUpdates = data => {
    const action = Object.keys(data.change)[0];

    // Check for add/remove with relation attributes
    if (singleActions.includes(action)) {
        const accessor = get(data.change[action], 'accessor');
        if (accessor === 'relations') {
            const relationAttributes = get(data.change[action], 'item.relation.attributes');
            if (relationAttributes && Object.keys(relationAttributes).length > 0) {
                return true;
            }
        }
        return false;
    }

    const change = data.change;
    const updateObj = change?.create || change?.update || {};
    const hasUpdateKeys = Object.keys(updateObj).length > 1;
    const hasPrimaryUpdateKeys = Object.keys(get(updateObj, 'primary', {})).length > 1;
    const hasPrimaryonCreate = !!Object.keys(get(updateObj, 'primary', {})).length >=1;
    const hasAttributeUpdateKeys = Object.keys(get(updateObj, 'attributes', {})).length > 1;
    const hasRelAttributeUpdateKeys = Object.keys(get(change, 'updateItem.update.attributes', {})).length > 1;
    const isClassUpdateKey = 'classes' in updateObj;
    const hasClassesValues = Array.isArray(updateObj.classes) && updateObj.classes.length > 0;
    const hasAttributesValues = updateObj.attributes && Object.keys(updateObj.attributes).length > 0;
    const hasPrimaryValues = updateObj.primary && Object.keys(updateObj.primary).length > 0;
    const isEntityIconNameUpdate = 'iconName' in updateObj && 'iconType' in updateObj && Object.keys(updateObj).length === 2; // if update has iconType consider as a single update
    const isRoleUpdate = 'role' in get(change, 'update.item', {});
    if (data.change?.create && hasPrimaryonCreate) return true;

    // If there are classes with values AND (attributes or primary with values) - it's a multiple update
    if (isClassUpdateKey && hasClassesValues && (hasAttributesValues || hasPrimaryValues)) {
        return true;
    }
    if (
        !isRoleUpdate && !isClassUpdateKey && !isEntityIconNameUpdate &&
            (hasUpdateKeys || hasPrimaryUpdateKeys || hasAttributeUpdateKeys || hasRelAttributeUpdateKeys)
    ) {
        return true;
    }

    return false;
};

const normalizeType = type => {
    switch (TRANSLATION_KEYS[type]) {
        case 'owner':
        case 'user':
            return 'entityUser';
        case 'script':
            return 'entityTypeScript';
        default:
            return TRANSLATION_KEYS[type] || type;
    }
};

const enrichValue = (value, key) => {
    if (!value && !isBoolean(value)) {
        return '';
    }
    if (isIsoDate(value)) {
        if (value.includes('T')) {
            return formatDate(value);
        }
        return formatDate(value, DATE_FORMAT)
    }
    if (key === 'priority') {
        return getPriorityLabel(value);
    }
    if (key === 'progress') {
        return `${value}%`;
    }
    if (key === 'dropzone' && Array.isArray(value)) {
        return value.map(v => v['path'] || '').join(', ');
    }
    if (isBoolean(value)) {
        return !value ? 'false' : 'true';
    }
    if (isObject(value)) {
        const { id, name, description } = value;
        return id ? (name || description || '') :'';
    }
    return value;
};

const checkEmptyAvatar = (avatar, id, type) => {
    if (avatar?.id) return avatar;

    avatar = set(avatar, 'id', id);
    avatar = set(avatar, 'type', TRANSLATION_KEYS[type] || type);

    return avatar;
};

export { checkIfMultipleUpdates, normalizeType, enrichValue, checkEmptyAvatar };
